module.exports = __webpack_public_path__ + "img/marketing-badge.af8b5f8d.png";